
import Vue from 'vue'

export default Vue.extend({
  name: 'JcdcTabHeader',
  props: { level: { type: Number, default: 1 } },
  computed: {
    headerClass() {
      switch (this.level) {
        case 2:
          return ' text-center px-5 primary--text primary lighten-5'
        case 3:
          return ' text-left px-2 primary--text text--lighten-1'
        default:
          return ' text-center px-5 py-1 primary--text text--darken-2 primary lighten-4'
      }
    },
  },
})
